// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/8d3fefca704e20c2225f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"c7e866531f1453e8758d","139":"7416db1f37d1723796e6","140":"684600ef0ca8f5d450df"}[chunkId] + ".chunk.js";
};